export const WARNING_FILE_SIZE = {
  ONE_MB: 1000000,
  FIFTY_MB: 50000000
};
export const WARNING_FILE_TYPE = 'gif';
export const MAX_DEFAULT_DIMENSION_PX = 2000;